var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "asc__insertPage" },
    [
      _c("CustomerTargetExcelModal", {
        on: { success: _vm.successExcelImportCustomerTarget }
      }),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { id: "credit-budget-confirm-delete-modal" },
          scopedSlots: _vm._u([
            {
              key: "modal-title",
              fn: function() {
                return [
                  _vm._v(
                    "\n      " + _vm._s(_vm.$t("list.deleteConfirm")) + "\n    "
                  )
                ]
              },
              proxy: true
            },
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "b-button",
                    {
                      staticClass: "float-right ml-2",
                      attrs: { size: "sm", variant: "outline-danger" },
                      on: {
                        click: function($event) {
                          return _vm.$bvModal.hide(
                            "credit-budget-confirm-delete-modal"
                          )
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("insert.cancel")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "float-right ml-2",
                      attrs: { size: "sm", variant: "success" },
                      on: {
                        click: function($event) {
                          return _vm.removeContractItems()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("insert.okay")))]
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [_vm._v("\n    " + _vm._s(_vm.$t("list.rowDeleteConfirm")) + "\n    ")]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { id: "credit-budget-confirm-edit-modal" },
          scopedSlots: _vm._u([
            {
              key: "modal-title",
              fn: function() {
                return [
                  _vm._v(
                    "\n      " + _vm._s(_vm.$t("list.editConfirm")) + "\n    "
                  )
                ]
              },
              proxy: true
            },
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "b-button",
                    {
                      staticClass: "float-right ml-2",
                      attrs: { size: "sm", variant: "outline-danger" },
                      on: {
                        click: function($event) {
                          return _vm.$bvModal.hide(
                            "credit-budget-confirm-edit-modal"
                          )
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("insert.cancel")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "float-right ml-2",
                      attrs: { size: "sm", variant: "success" },
                      on: {
                        click: function($event) {
                          return _vm.editInvoiceLine()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("insert.okay")))]
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [_vm._v("\n    " + _vm._s(_vm.$t("list.rowEditConfirm")) + "\n    ")]
      ),
      _vm._v(" "),
      _c("b-col", { attrs: { cols: "12" } }, [
        _c(
          "header",
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12", md: "8" } },
                  [_c("Breadcrumb")],
                  1
                ),
                _vm._v(" "),
                _c(
                  "b-col",
                  { staticClass: "text-right", attrs: { cols: "12", md: "4" } },
                  [
                    _c(
                      "router-link",
                      { attrs: { to: { name: "CustomerTarget" } } },
                      [_c("CancelButton")],
                      1
                    ),
                    _vm._v(" "),
                    _c("AddButton", {
                      nativeOn: {
                        click: function($event) {
                          return _vm.save()
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "asc__insertPage-content-head", attrs: { cols: "12" } },
        [
          _c(
            "section",
            [
              _c(
                "b-row",
                [
                  _c(
                    "NextFormGroup",
                    { attrs: { "item-key": "Code", error: _vm.$v.form.Code } },
                    [
                      _c("NextInput", {
                        attrs: {
                          type: "text",
                          disabled: _vm.insertReadonly.Code
                        },
                        model: {
                          value: _vm.form.Code,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Code", $$v)
                          },
                          expression: "form.Code"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "ErpCode",
                        error: _vm.$v.form.ErpCode
                      }
                    },
                    [
                      _c("NextInput", {
                        attrs: {
                          type: "text",
                          disabled: _vm.insertReadonly.ErpCode
                        },
                        model: {
                          value: _vm.form.ErpCode,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "ErpCode", $$v)
                          },
                          expression: "form.ErpCode"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "Description1",
                        error: _vm.$v.form.Description1
                      }
                    },
                    [
                      _c("NextInput", {
                        attrs: {
                          type: "text",
                          disabled: _vm.insertReadonly.Description1
                        },
                        model: {
                          value: _vm.form.Description1,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "Description1", $$v)
                          },
                          expression: "form.Description1"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "TciBreak1Id",
                        error: _vm.$v.form.TciBreak1Id
                      }
                    },
                    [
                      _c("NextDropdown", {
                        attrs: {
                          disabled: _vm.insertReadonly.TciBreak1Id,
                          "lookup-key": "TCI_BREAKDOWN"
                        },
                        on: {
                          input: function($event) {
                            return _vm.selectedType("TciBreak1Id", $event)
                          }
                        },
                        model: {
                          value: _vm.tciBreak,
                          callback: function($$v) {
                            _vm.tciBreak = $$v
                          },
                          expression: "tciBreak"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "ItemColumnName",
                        error: _vm.$v.form.ItemColumnName
                      }
                    },
                    [
                      _c("NextDropdown", {
                        attrs: {
                          disabled: _vm.insertReadonly.ItemColumnName,
                          source: _vm.itemCriterias,
                          "dynamic-request": { paramId: "ITEM_CRITERIA" },
                          label: "Label"
                        },
                        on: {
                          input: function($event) {
                            return _vm.selectColumnName($event)
                          }
                        },
                        model: {
                          value: _vm.itemColumnName,
                          callback: function($$v) {
                            _vm.itemColumnName = $$v
                          },
                          expression: "itemColumnName"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "ItemColumnValue",
                        error: _vm.$v.form.ItemColumnValue
                      }
                    },
                    [
                      _c("NextDropdown", {
                        attrs: {
                          disabled: _vm.insertReadonly.ItemColumnValue,
                          source: _vm.fieldValues,
                          label: "Label"
                        },
                        on: {
                          input: function($event) {
                            return _vm.selectedType($event)
                          }
                        },
                        model: {
                          value: _vm.itemColumnValue,
                          callback: function($$v) {
                            _vm.itemColumnValue = $$v
                          },
                          expression: "itemColumnValue"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "NextFormGroup",
                    {
                      attrs: {
                        "item-key": "StatusId",
                        error: _vm.$v.form.StatusId
                      }
                    },
                    [
                      _c("NextCheckBox", {
                        attrs: { type: "number", toggle: "" },
                        model: {
                          value: _vm.statusToggle,
                          callback: function($$v) {
                            _vm.statusToggle = $$v
                          },
                          expression: "statusToggle"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _c(
            "b-tabs",
            [
              _c(
                "b-tab",
                {
                  attrs: {
                    title: _vm.$t("insert.CustomerTarget.CustomerTargetDetails")
                  }
                },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t("insert.CustomerTarget.CustomerId"),
                            error: _vm.$v.customerTargetDetails.Customer,
                            required: true,
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              url:
                                "VisionNextCustomer/api/Customer/AutoCompleteSearch",
                              "dynamic-and-condition": { StatusIds: [1] },
                              label: "Description1",
                              searchable: true,
                              "custom-option": true,
                              "is-customer": true
                            },
                            model: {
                              value: _vm.customerTargetDetails.Customer,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.customerTargetDetails,
                                  "Customer",
                                  $$v
                                )
                              },
                              expression: "customerTargetDetails.Customer"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t(
                              "insert.CustomerTarget.TargetQuantity"
                            ),
                            error: _vm.$v.customerTargetDetails.TargetQuantity,
                            required: true,
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: { type: "number" },
                            model: {
                              value: _vm.customerTargetDetails.TargetQuantity,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.customerTargetDetails,
                                  "TargetQuantity",
                                  $$v
                                )
                              },
                              expression: "customerTargetDetails.TargetQuantity"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t("insert.CustomerTarget.TargetUnitId"),
                            error: _vm.$v.customerTargetDetails.TargetUnit,
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              disabled: true,
                              source: _vm.lookupValues,
                              label: "Label"
                            },
                            model: {
                              value: _vm.customerTargetDetails.TargetUnit,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.customerTargetDetails,
                                  "TargetUnit",
                                  $$v
                                )
                              },
                              expression: "customerTargetDetails.TargetUnit"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t("insert.CustomerTarget.ReqItemId"),
                            error: _vm.$v.customerTargetDetails.ReqItem,
                            required: !(
                              _vm.customerTargetDetails.Customer &&
                              _vm.customerTargetDetails.TargetQuantity &&
                              _vm.customerTargetDetails.GainAmount
                            ),
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: {
                              "dynamic-and-condition": { StatusIds: [1] },
                              url:
                                "/VisionNextItem/api/Item/AutocompleteSearch",
                              searchable: true,
                              source: _vm.items,
                              orConditionFields: "Code,Description1",
                              "custom-option": true
                            },
                            model: {
                              value: _vm.customerTargetDetails.ReqItem,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.customerTargetDetails,
                                  "ReqItem",
                                  $$v
                                )
                              },
                              expression: "customerTargetDetails.ReqItem"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t(
                              "insert.CustomerTarget.ReqItemQuantity"
                            ),
                            error: _vm.$v.customerTargetDetails.ReqItemQuantity,
                            required: !(
                              _vm.customerTargetDetails.Customer &&
                              _vm.customerTargetDetails.TargetQuantity &&
                              _vm.customerTargetDetails.GainAmount
                            ),
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: { type: "number" },
                            model: {
                              value: _vm.customerTargetDetails.ReqItemQuantity,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.customerTargetDetails,
                                  "ReqItemQuantity",
                                  $$v
                                )
                              },
                              expression:
                                "customerTargetDetails.ReqItemQuantity"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t(
                              "insert.CustomerTarget.DescriptionReqItem"
                            ),
                            error:
                              _vm.$v.customerTargetDetails.DescriptionReqItem,
                            required: !(
                              _vm.customerTargetDetails.Customer &&
                              _vm.customerTargetDetails.TargetQuantity &&
                              _vm.customerTargetDetails.GainAmount
                            ),
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: { type: "text" },
                            model: {
                              value:
                                _vm.customerTargetDetails.DescriptionReqItem,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.customerTargetDetails,
                                  "DescriptionReqItem",
                                  $$v
                                )
                              },
                              expression:
                                "customerTargetDetails.DescriptionReqItem"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t("insert.CustomerTarget.GainAmount"),
                            error: _vm.$v.customerTargetDetails.GainAmount,
                            required: true,
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextInput", {
                            attrs: { type: "number" },
                            model: {
                              value: _vm.customerTargetDetails.GainAmount,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.customerTargetDetails,
                                  "GainAmount",
                                  $$v
                                )
                              },
                              expression: "customerTargetDetails.GainAmount"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "NextFormGroup",
                        {
                          attrs: {
                            title: _vm.$t("insert.CustomerTarget.currencyId"),
                            error: _vm.$v.customerTargetDetails.Currency,
                            required: true,
                            md: "3",
                            lg: "3"
                          }
                        },
                        [
                          _c("NextDropdown", {
                            attrs: { disabled: true, source: _vm.currencies },
                            model: {
                              value: _vm.customerTargetDetails.Currency,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.customerTargetDetails,
                                  "Currency",
                                  $$v
                                )
                              },
                              expression: "customerTargetDetails.Currency"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "12", md: "2" } },
                        [
                          _c(
                            "b-form-group",
                            [
                              _c("AddDetailButton", {
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.addCustomerGuarantee($event)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "12", md: "2" } },
                        [
                          _c(
                            "b-form-group",
                            [
                              _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "b-modal",
                                      rawName:
                                        "v-b-modal.customer-target-excel-modal",
                                      modifiers: {
                                        "customer-target-excel-modal": true
                                      }
                                    }
                                  ],
                                  staticClass: "mt-4",
                                  attrs: { size: "sm", variant: "success" }
                                },
                                [
                                  _c("i", { staticClass: "fas fa-file-pdf" }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "insert.creditBudget.uploadExcel"
                                        )
                                      )
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("b-table", {
                        attrs: {
                          items: _vm.CustomerTarget
                            ? _vm.CustomerTarget.filter(function(c) {
                                return c.RecordState !== 4
                              })
                            : [],
                          fields: _vm.customerGuaranteeFields,
                          striped: "",
                          small: "",
                          "sticky-header": "300px",
                          responsive: "",
                          "select-mode": "multi",
                          selectable: "",
                          bordered: "",
                          "current-page": _vm.currentPage,
                          "per-page": 0
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "head()",
                            fn: function(data) {
                              return [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t(data.label)) +
                                    "\n            "
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(operations)",
                            fn: function(row) {
                              return [
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "btn mr-2 btn-warning btn-sm",
                                    attrs: { title: _vm.$t("list.edit") },
                                    on: {
                                      click: function($event) {
                                        _vm.$bvModal.show(
                                          "credit-budget-confirm-edit-modal"
                                        )
                                        _vm.selectedCustomerTarget = row.item
                                      }
                                    }
                                  },
                                  [_c("i", { staticClass: "fa fa-pencil-alt" })]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "btn mr-2 btn-danger btn-sm",
                                    attrs: {
                                      title: _vm.$t("list.delete"),
                                      type: "button"
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.$bvModal.show(
                                          "credit-budget-confirm-delete-modal"
                                        )
                                        _vm.selectedCustomerTarget = row.item
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "far fa-trash-alt ml-1"
                                    })
                                  ]
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("b-pagination", {
                        attrs: {
                          "total-rows": _vm.totalRowCount,
                          "per-page": 50,
                          "aria-controls": "customer-target-list"
                        },
                        model: {
                          value: _vm.currentPage,
                          callback: function($$v) {
                            _vm.currentPage = $$v
                          },
                          expression: "currentPage"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                {
                  attrs: {
                    title: _vm.$t("insert.CustomerTarget.CustomerTargetDates")
                  }
                },
                [
                  _c("NextDetailPanel", {
                    attrs: { items: _vm.customerTargetDatesItems },
                    model: {
                      value: _vm.form.CustomerTargetDates,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "CustomerTargetDates", $$v)
                      },
                      expression: "form.CustomerTargetDates"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9df46156", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9df46156","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/CustomerTarget/update.vue
// module id = null
// module chunks = 